import React, { useState } from 'react';
import styled from 'styled-components';

import { WindowDropDowns } from 'components';
import dropDownData from './dropDownData';

export default function Notepad({ onClose, hasNotepadOpened }) {
  const [docText, setDocText] = useState(
    hasNotepadOpened
      ? ''
      : "¸,ø¤º°`°º¤ø,¸¸,ø¤º°WELCOME TO AMINA WORLD!!!°º¤ø,¸¸,ø¤º°`°º¤ø,¸\n\n\nCheck out my writing on Expat: https://expatpress.com/bodies-and-public-spaces-amina-snoot/ \n\nor my music on Soundcloud: https://soundcloud.com/defaultgirl \n\nI'm on Bandcamp too: https://djsloophipsterthegod.bandcamp.com/track/o-n-l-i-n-e-l-i-t-q-u-e-e-n-s-feat-default-girl \n\nand on donotsubmit: https://donotsubmit.net/online-lit-queens-full-lyrics-by-plasticbagger-and-default-girl/ \n\nI'm even on Substack: https://aminasnoot.substack.com/ \n\nWhat about some video work: https://youtu.be/xN5xv2BV8g4 \n\n ☺︎ \n\n\nCLICK THE MY DOCUMENTS FOLDER!!! \n\n\n ☺︎ \n\n\nhelp@aminaworld.net",
  );
  const [wordWrap, setWordWrap] = useState(true);

  function onClickOptionItem(item) {
    switch (item) {
      case 'Exit':
        onClose();
        break;
      case 'Word Wrap':
        setWordWrap(!wordWrap);
        break;
      case 'Time/Date':
        const date = new Date();
        setDocText(
          `${docText}${date.toLocaleTimeString()} ${date.toLocaleDateString()}`,
        );
        break;
      default:
    }
  }
  function onTextAreaKeyDown(e) {
    // handle tabs in text area
    if (e.which === 9) {
      e.preventDefault();
      e.persist();
      var start = e.target.selectionStart;
      var end = e.target.selectionEnd;
      setDocText(`${docText.substring(0, start)}\t${docText.substring(end)}`);

      // asynchronously update textarea selection to include tab
      // workaround due to https://github.com/facebook/react/issues/14174
      requestAnimationFrame(() => {
        e.target.selectionStart = start + 1;
        e.target.selectionEnd = start + 1;
      });
    }
  }

  return (
    <Div>
      <section className="np__toolbar">
        <WindowDropDowns items={dropDownData} onClickItem={onClickOptionItem} />
      </section>
      <StyledTextarea
        wordWrap={wordWrap}
        value={docText}
        onChange={e => setDocText(e.target.value)}
        onKeyDown={onTextAreaKeyDown}
        spellCheck={false}
      />
    </Div>
  );
}

const Div = styled.div`
  height: 100%;
  background: linear-gradient(to right, #edede5 0%, #ede8cd 100%);
  display: flex;
  flex-direction: column;
  align-items: stretch;
  .np__toolbar {
    position: relative;
    height: 21px;
    flex-shrink: 0;
    border-bottom: 1px solid white;
  }
`;

const StyledTextarea = styled.textarea`
  flex: auto;
  outline: none;
  font-family: 'Lucida Console', monospace;
  font-size: 13px;
  line-height: 14px;
  resize: none;
  padding: 2px;
  ${props => (props.wordWrap ? '' : 'white-space: nowrap; overflow-x: scroll;')}
  overflow-y: scroll;
  border: 1px solid #96abff;
`;
